import { render, staticRenderFns } from "./MySSLCertificateTable.vue?vue&type=template&id=19e1631e"
import script from "./MySSLCertificateTable.vue?vue&type=script&lang=js"
export * from "./MySSLCertificateTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports